exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-eec902ee] .el-table{font-size:13px}[data-v-eec902ee] .el-table .cell{line-height:14px}", ""]);

// exports
